import { v4 } from "uuid";

export class FrontendFuncParam {
	id:string = v4();
	Name:string = "nieuweParamater";
	Description:string = "Parameter zonder beschrijving";

	public constructor(data?:any) {
		if (!data) return;
		this.Name = data.Name;
		this.Description = data.Description;
	}

	public getJSON(){
		return {
			Name: this.Name,
			Description: this.Description
		};
	}
}